const classScheduleData = {
  MONDAY: [
    {
      time: "4:30 PM",
      room: "RM 1",
      class: "Ballet/Pointe - PreTeen/Teen",
    },
    {
      time: "4:30 PM",
      room: "RM 2",
      class: "Hip Hop I-II Youth 6.5+",
    },
    {
      time: "4:30 PM",
      room: "RM 3",
      class: "Pre Kinder Dance 4.5-5.5",
    },
    {
      time: "4:30 PM",
      room: "RM 4",
      class: "Pom Dance 9-13yrs",
    },
    {
      time: "5:30 PM",
      room: "RM 1",
      class: "Ballet IV-V Youth",
    },
    {
      time: "5:30 PM",
      room: "RM 2",
      class: "Stretch and Strength",
    },
    {
      time: "5:30 PM",
      room: "RM 3",
      class: "Modern Youth",
    },
    {
      time: "5:30 PM",
      room: "RM 4",
      class: "Tap Int/Adv Youth",
    },
    {
      time: "6:30 PM",
      room: "RM 1",
      class: "Adult Ballet Int/Adv",
    },
    {
      time: "6:30 PM",
      room: "RM 2",
      class: "Lyrical/Contemporary Int/Adv 13+",
    },
    {
      time: "6:30 PM",
      room: "RM 3",
      class: "Latin Heels/Ballroom and More! Basic/Int.",
    },
    {
      time: "6:30 PM",
      room: "RM 4",
      class: "Teen Ballet Basic/Int",
    },
    {
      time: "7:30 PM",
      room: "RM 1",
      class: "Adult Modern",
    },
    {
      time: "7:30 PM",
      room: "RM 2",
      class: "Hip Hop Adv",
    },
    {
      time: "7:30 PM",
      room: "RM 3",
      class: "Adult Ballet Basic",
    },
  ],

  TUESDAY: [
    {
      time: "10:30 AM",
      room: "RM 1",
      class: "Adult Ballet",
    },
    {
      time: "1:00 PM",
      room: "RM 3",
      class: "Flamenco",
    },
    {
      time: "4:30 PM",
      room: "RM 1",
      class: "Jazz Basic Youth",
    },
    {
      time: "4:30 PM",
      room: "RM 2",
      class: "Ballet/Pointe II-III",
    },
    {
      time: "4:30 PM",
      room: "RM 3",
      class: "Tap Basic Youth",
    },
    {
      time: "4:30 PM",
      room: "RM 4",
      class: "Pre Tap 4.5-6.5",
    },
    {
      time: "5:30 PM",
      room: "RM 1",
      class: "Ballet III-IV Youth",
    },
    {
      time: "5:30 PM",
      room: "RM 2",
      class: "Ballet/Pointe II-III",
    },
    {
      time: "5:30 PM",
      room: "RM 3",
      class: "Pom Dance Youth 6-9yrs",
    },
    {
      time: "5:30 PM",
      room: "RM 4",
      class: "Tap Int Youth",
    },
    {
      time: "6:30 PM",
      room: "RM 1",
      class: "Tap Adv",
    },
    {
      time: "6:30 PM",
      room: "RM 2",
      class: "Jazz Int Teen",
    },
    {
      time: "6:30 PM",
      room: "RM 3",
      class: "Adult Tap Int/Adv",
    },
    {
      time: "7:30 PM",
      room: "RM 1",
      class: "Adult Hip Hop Fusion",
    },
    {
      time: "7:30 PM",
      room: "RM 2",
      class: "Jazz Adv",
    },
    {
      time: "7:30 PM",
      room: "RM 3",
      class: "Adult Tap Basic/Int",
    },
  ],

  WEDNESDAY: [
    {
      time: "3:30 PM",
      room: "RM 2",
      class: "Ballet I-II-A",
    },
    {
      time: "3:30 PM",
      room: "RM 3",
      class: "Pre-Kinder Dance 3.5-5",
    },
    {
      time: "4:30 PM",
      room: "RM 1",
      class: "Jazz II-III Youth",
    },
    {
      time: "4:30 PM",
      room: "RM 2",
      class: "Ballet/Pointe Adv",
    },
    {
      time: "4:30 PM",
      room: "RM 3",
      class: "Hip Hop Basic/Int 8+",
    },
    {
      time: "4:30 PM",
      room: "RM 4",
      class: "Ballet II-III A",
    },
    {
      time: "5:30 PM",
      room: "RM 1",
      class: "Jazz Int/Adv Youth",
    },
    {
      time: "5:30 PM",
      room: "RM 2",
      class: "Ballet/Pointe Adv",
    },
    {
      time: "5:30 PM",
      room: "RM 3",
      class: "Hip Hop Int Teen",
    },
    {
      time: "5:30 PM",
      room: "RM 4",
      class: "Ballet Basic Youth",
    },
    {
      time: "6:30 PM",
      room: "RM 1",
      class: "Acrobatics Int/Adv",
    },
    {
      time: "6:30 PM",
      room: "RM 3",
      class: "Teacher's Tap",
    },
    {
      time: "7:30 PM",
      room: "RM 1",
      class: "Acrobatics Adv",
    },
    {
      time: "7:30 PM",
      room: "RM 2",
      class: "Teacher's/Adult Jazz/Contemp",
    },
    {
      time: "7:30 PM",
      room: "RM 3",
      class: "Men's Tap",
    },
  ],

  THURSDAY: [
    {
      time: "10:30 AM",
      room: "RM 1",
      class: "Adult Ballet",
    },
    {
      time: "4:30 PM",
      room: "RM 1",
      class: "Hip Hop Beg/Int Youth",
    },
    {
      time: "4:30 PM",
      room: "RM 2",
      class: "Lyrical/Contemp Int. 10+",
    },
    {
      time: "4:30 PM",
      room: "RM 3",
      class: "Pre Kinder Dance 3-4",
    },
    {
      time: "4:30 PM",
      room: "RM 4",
      class: "Pre Hip Hop 4.5-6.5",
    },
    {
      time: "5:30 PM",
      room: "RM 1",
      class: "Modern - Adv",
    },
    {
      time: "5:30 PM",
      room: "RM 2",
      class: "Hip Hop Int/Adv Youth",
    },
    {
      time: "5:30 PM",
      room: "RM 3",
      class: "Adult Tap Int",
    },
    {
      time: "6:30 PM",
      room: "RM 1",
      class: "Adult MT/Broadway",
    },
    {
      time: "6:30 PM",
      room: "RM 2",
      class: "FDC Skills",
    },
    {
      time: "6:30 PM",
      room: "RM 3",
      class: "Tap Teen I-II",
    },
    {
      time: "7:30 PM",
      room: "RM 2",
      class: "Latin Heels/Ballroom and More! Int/Adv",
    },
    {
      time: "7:30 PM",
      room: "RM 3",
      class: "Jazz Teen I-II",
    },
  ],

  FRIDAY: [
    {
      time: "4:30 PM",
      room: "RM 1",
      class: "Acrobatics Primary",
    },
    {
      time: "5:30 PM",
      room: "RM 1",
      class: "Acrobatics Int Younger",
    },
    {
      time: "6:30 PM",
      room: "RM 1",
      class: "Acrobatics Int Older",
    },
  ],

  SATURDAY: [
    {
      time: "9:00 AM",
      room: "RM 1",
      class: "Jazz I-II",
    },
    {
      time: "9:00 AM",
      room: "RM 2",
      class: "Pre Kinder Dance 4.5-5.5",
    },
    {
      time: "9:00 AM",
      room: "RM 3",
      class: "Pre Kinder Dance 3-4",
    },
    {
      time: "10:00 AM",
      room: "RM 1",
      class: "Pre Hip Hop 4.5-6.5",
    },
    {
      time: "10:00 AM",
      room: "RM 2",
      class: "Ballet II-A",
    },
    {
      time: "10:00 AM",
      room: "RM 3",
      class: "Pre Kinder Dance 3-4",
    },
    {
      time: "10:00 AM",
      room: "RM 4",
      class: "Ballet I-II Youth",
    },
    {
      time: "11:00 AM",
      room: "RM 1",
      class: "Modern Int/Adv",
    },
    {
      time: "11:00 AM",
      room: "RM 2",
      class: "Jazz Int Youth",
    },
    {
      time: "11:00 AM",
      room: "RM 3",
      class: "Ballet III-A",
    },
    {
      time: "12:00 PM",
      room: "RM 1",
      class: "Ballet/Pointe Int/Adv",
    },
    {
      time: "12:00 PM–1:30 PM",
      room: "RM 2",
      class: "FDC Novas",
    },
    {
      time: "12:00 PM",
      room: "RM 3",
      class: "Ballet Int Youth",
    },
    {
      time: "1:00 PM",
      room: "RM 1",
      class: "Ballet/Pointe Int/Adv",
    },
    {
      time: "1:00 PM–2:30 PM",
      room: "RM 2",
      class: "Combined Skills - SuperNovas",
    },
    {
      time: "1:00 PM–2:30 PM",
      room: "RM 2/1",
      class: "FDC Superstars",
    },
    {
      time: "2:00 PM",
      room: "RM 2",
      class: "Hip Hop/Jazz Funk Adv",
    },
  ],
};

export default classScheduleData;
